// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"erp-chart-container","216":"vendors","978":"price-chart"}[chunkId] + "." + {"57":"f11673f7e348517aa2cc","216":"9c4019e5e1ebaf244dfc","978":"05c3e26d0979ff896df6"}[chunkId] + ".js";
};